//import { useField } from 'formik';
import React from 'react';
import { IMaskedInputProps } from './../types/types';
import { TextField } from '@material-ui/core';
const getDigitsFromValue = (value = '') =>
  value.replace(/(-(?!\d))|[^0-9|-]/g, '') || '';
const padDigits = digits => {
  const desiredLength = 3;
  const actualLength = digits.length;
  if (actualLength >= desiredLength) {
    return digits;
  }
  const amountToAdd = desiredLength - actualLength;
  const padding = '0'.repeat(amountToAdd);
  return padding + digits;
};
const removeLeadingZeros = number => number.replace(/^0+([0-9]+)/, '$1');
const addDecimalToNumber = (number, separator) => {
  const centsStartingPosition = number.length - 2;
  const dollars = removeLeadingZeros(
    number.substring(0, centsStartingPosition),
  );
  const cents = number.substring(centsStartingPosition);
  return dollars + separator + cents;
};
const toCurrency = (value, separator = '.') => {
  const digits = getDigitsFromValue(value);
  const digitsWithPadding = padDigits(digits);
  return addDecimalToNumber(digitsWithPadding, separator);
};
const MaskedInput: React.FC<IMaskedInputProps> = React.forwardRef(
  ({ label, disabled, ...props }: IMaskedInputProps, ref: any) => {
    const onChange = React.useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const { separator } = props;
        const value = event.target.value;
        const valueAsCurrency = toCurrency(value, separator);

        if (!(valueAsCurrency > 9999.99)) {
          if (props.onChange) {
            event.persist();
            props.onChange(valueAsCurrency);
          }
        } else {
          if (props.onChange) {
            event.persist();
            props.onChange('9999.99');
          }
        }
      },
      [props],
    );

    return (
      <div style={{ textAlign: 'right' }}>
        <TextField
          id={props + 'tst4'}
          error={props.error}
          //helperText="Incorrect entry."
          value={props.value}
          disabled={disabled}
          variant="outlined" // Add an outline style
          style={{
            width: props.width,
          }}
          InputProps={{
            style: {
              height: '37px',
              fontSize: '12.5px',
              alignItems:"right"
            },
          }}
          onChange={onChange}
        />
      </div>
    );
  },
);
export default MaskedInput;
